/**
 * Parâmetros de embed Supervisor → webphone (Fase 3).
 */
export function parseEmbedSearchParams(search = '') {
  const params = new URLSearchParams(
    search.startsWith('?') ? search : `?${search}`
  );

  return {
    embed:
      params.get('embed') === 'supervisor' ||
      params.get('source') === 'supervisor',
    configUrl: params.get('config') || params.get('configUrl') || '',
    username: params.get('agent') || params.get('username') || '',
    groupName: params.get('group') || params.get('grupo') || ''
  };
}
